export default "__VITE_ASSET__YRa3Lahe__"